import { Link, Div, Paragraph, Span } from "@tblabs/truffle";
import { HtmlArticle } from "../../Components/Product/Card";
import { ProductCardFigure } from "../../Components/Product/CardFigure";
import { Icons } from "../../Components/Utils/Icons";
import { BlogArticle } from "../../Models/Blog/BlogArticle";
import { Svg } from "../Components/Utils/Svg";


export class AricleBox extends HtmlArticle
{
    constructor(article: BlogArticle)
    {
        super("product-card group");

        this.OnClick(() => window.location.hash = `blog/${article.Url.value}`);

        this.Append(
            new Link("", article.Url.value).Class("product-card__link")
                .Append(
                    new ProductCardFigure(article.Images.First()?.ThumbnailUrl.value ?? ""),
                    new Div("product-card__content").Append(
                        new Div("product-card__title")
                            .Text(article.Title.value),
                        new Paragraph("product-card__description").Text(article.Subtitle.value ?? ""),
                        new Div("product-card__footer justify-right")
                            .Append(
                                new Div("product-card__button")
                                    .Append(
                                        new Span("Czytaj"),
                                        new Svg(Icons.ArrowRight)
                                    )
                            )
                    )
                )
        );
    }
}
